import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  constructor(private router: Router,private translateservice: TranslateService ){

    this.currentLanguage = this.translateservice.currentLang;

    this.translateservice.onLangChange.subscribe((event) => {

      this.currentLanguage = event.lang;

    });

  }

//  
 
//  isClicked: boolean = false;
heightClass: string = 'height-normal'; // Default height class

currentLanguage : string;

ngOnInit() {
  const savedHeightClass = localStorage.getItem('heightClass');
  if (savedHeightClass) {
    this.heightClass = savedHeightClass;
  }
}

changeHeight(newHeightClass: string) {
  this.heightClass = newHeightClass;
  localStorage.setItem('heightClass', newHeightClass);
}


GotoTourDashboard() { this.router.navigate(['/tours']);
  this.changeHeight('height-dashboard');
 }
   GotoSchedule_a_tour() { this.router.navigate(['/schedule-a-tour']);
    this.changeHeight('height-schedule-a-tour');
    }
   GotoMy_tours(){this.router.navigate(['/my-tours']);
    this.changeHeight('height-my-tours');
   }
   Goto_feedback(){this.router.navigate(['/Feedback-view']);
    this.changeHeight('height-Feedback-view');
   }

//   GotoMy_tours(){this.router.navigate(['/my-tours'])
//  }
}
